import { connect } from "react-redux";
import { useIntl } from "react-intl";
import * as ListCellRenders from "../../../common/list/ListCellRenders";
import List from "../../../common/list";

export const LearningUsersSummary = ({
  data,
  sections,
  query,
  setQuery,
  loading = false,
  totalRecords = 0,
  // The level's item, as the admin screen and the export head the column
  // (it was "Learning Object" at every level, B-BUG-8).
  learningName = "learning_object",
}) => {
  const intl = useIntl();

  const customFields = sections.reduce((acc, section) => {
    acc = [
      ...acc,
      ...(section?.fields?.map((item) => ({
        id: item.id,
        name: item.name,
        value: item.id,
        type: item.type,
        label: item.label,
      })) || []),
    ];
    return acc;
  }, []);

  const columns = [
    {
      field: "firstName",
      header: "name",
      sortable: true,
      body: ListCellRenders.FullNameAndEmail(),
    },
    {
      field: "learningName",
      header: learningName,
    },
    {
      field: "status",
      header: "status",
      body: (data) => {
        let status = data.status.toLowerCase();
        let color = "var(--orange-500)";
        if (status === "completed") {
          color = "var(--green-500)";
        } else if (status === "overdue") {
          color = "var(--red-500)";
        } else if (
          status === "inprogress" ||
          status === "started" ||
          status === "incomplete"
        ) {
          status = "inprogress";
          color = "#0EA5E9";
        }

        return (
          <div
            style={{
              backgroundColor: color,
              color: "white",
              width: "100px",
              textAlign: "center",
              borderRadius: "5px",
              padding: "2px",
            }}
            className="text-sm"
          >
            {intl.formatMessage({ id: status }).toUpperCase()}
          </div>
        );
      },
    },
    {
      field: "designation",
      header: "designation",
      sortable: true,
      body: ListCellRenders.StringData("designation"),
    },
    {
      field: "department",
      header: "department",
      sortable: true,
      body: ListCellRenders.StringData("department"),
    },
    {
      field: "isActive",
      header: "user_status",
      sortable: true,
      body: ListCellRenders.Status,
    },
    ...customFields
      .filter((item) => item.type !== 5)
      .map((item) => ({
        field: item.label,
        header: item.label,
        sortable: false,
        i18n: false,
        body: (rowData) => {
          return (
            rowData?.dynamicValues?.find(
              (field) => field.customFieldId === item.id
            )?.value || "-"
          );
        },
      })),
  ];

  const handlePageChange = (pageData) => {
    if (
      query.pageSize !== pageData.rows ||
      query.pageNo !== pageData.page + 1
    ) {
      setQuery({
        ...query,
        pageNo: pageData.page + 1,
        pageSize: pageData.rows,
      });
    }
  };

  const handleOnSortChange = (sortData) => {
    setQuery({
      ...query,
      pageNo: 1,
      sortColumn: sortData.sortField,
      sortBy: sortData.sortOrder === 1 ? "asc" : "desc",
    });
  };

  columns.splice(
    columns.findIndex((col) => col.field === "learningName") + 1,
    0,
    {
      field: "isOptional",
      header: "training_type",
      body: ListCellRenders.TrainingType,
    }
  );

  return (
    <List
      loading={loading}
      totalRecords={totalRecords}
      handlePageChange={handlePageChange}
      handleOnSortChange={handleOnSortChange}
      data={data || []}
      pageQuery={query}
      columns={columns}
      selectionMode=""
    />
  );
};

const mapStateToProps = (state) => ({
  sections: state.customFields.data,
});

export default connect(mapStateToProps)(LearningUsersSummary);
